import { useCallback } from "react";

import { useAppSelector } from "store/index";
import { sectionSelectors } from "store/selectors";

/** Returns a stable factory that maps a term ID to the Set of course IDs with sections in that term. */
export function useCourseIdsInTerm(): (termId: string) => Set<string> {
  const sections = useAppSelector(sectionSelectors.selectAll);
  return useCallback(
    (termId: string) =>
      new Set(sections.filter((s) => s.term_id === termId).map((s) => s.course_id)),
    [sections],
  );
}
